define('LNRS/Track/Events',[],function () {

    return {
        global: {
            algoliaRendered: "algoliaRendered",
            formSubmitted: "formSubmitted",
            formErrors: "formErrors",
            eloquaFormSubmitted: "eloquaFormSubmitted",
            videoStateChange: "videoStateChange",
            vwoEloquaFormSuccess: "VWOEloquaFormSuccess"
        }
    };
});
